module.exports = __webpack_public_path__ + "03_long_grey.d011f98a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/03_long_grey.png
// module id = pv78
// module chunks = 0